import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { normalizeUrlHref } from "./utils";
import { Params } from "../../helpers";
import { getByPath } from "./utils";

export const createUrlCell = (
  _params: Params,
  accessorPath: string,
  _pageData?: GetPageResponse,
) => ({
  component: "UrlLink" as const,
  generateProps: (row: Record<string, unknown>) => {
    const raw = getByPath(row, accessorPath);
    const value = typeof raw === "string" ? raw.trim() : "";
    return {
      href: value ? normalizeUrlHref(value) : "",
      label: value,
    };
  },
});
